









































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { Competence, UpdateCompetenceModel } from "@/api/models/competences/competence";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-competence",
})
export default class EditCompetence extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateCompetenceSidebarActive!: boolean;
  @Prop({ required: true }) competenceId!: string;

  loading = false;
  required = required;
  loadingCompetence = false;

  competence: UpdateCompetenceModel = {};

  async created() {
    await this.$http.myressif.competences
      .getById(this.competenceId)
      .then((res: Competence) => {
        this.competence = res;
        this.loadingCompetence = true;
      });
  }

  resetForm() {
    this.competence = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.competences
      .update(
        this.competenceId,
        this.competence
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification de la compétence",
            text: "Compétence modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-competences");
        this.$emit("update:is-update-competence-sidebar-active", false);
        this.loading = false;
      });
  }
}
